export default "__VITE_ASSET__CYqNIrtQ__"